import axios from 'axios';
import CryptoJS, { mode } from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import AdminSettingsService from './../../../services/adminsettings.service';
import {Validator} from 'vee-validate';
import CargoAllocationService from '../../../../cargoallocation/services/cargoallocation.service'
import MasterService from '../../../../masterdata/services/masterdata.service'
import ClientService from '../../../../clientmanagement/services/clientmanagement.service'
export default {
  name: 'changedefaulthub',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  props: [],
  data: function() {
    return {
      isLoading:false,
      adminsettingdata:[],
      HSNCode:"",
      StatesLimit:[],
      SelectedStates:'',
      exemptHSN:'',
      states:'',
      printstickeroptions:"",
      cft:'',
      hubaccess:[],
      hubaccessObjArray:[],
      currentHub:'',
      hubid:'',
      hubid1:'',
      isPalletScan:'',
      scanType:'',
      originhubids:null,
      destinationhubids:null,
      Clientlist:[],
      ClientBusinessAccountlist:[],
	  ClientOTPlist:[],
	  selectedOTPClients:[],
      selectedClients:[],
      selectedClientsForClientRefNo:[],
      selectedClientsForRefNo:[],
      selectedClientsForDisabledWt:[],
      selectedTables:[],
      redisService: 0,
      MaxVolWt : null,
      MaxVolWtAWB : null,
      ftccashlimit:"",
      prcutofftime:"",
      FTCAMterr:"",
      RolesList:[],
      roleId:'',
      rolename:'',
      autocutoffweight:"",
      autofetchdatalimit:"",
      prCutoofSelected:0,
      prCutoofBackspace:0,
	  mpsPrintDisabledClients:"",
	  OTPBasedDelivery:"",
	  ClientReferenceNolist:"",
	  ReferenceNolist:"",
	  ClientsForDisabledWt:"",
	  clientlist:[],
      ShowClientDetails:false,
	  clinetnamelist:"",
	ShowAwbCopy:false,
	ShowMpsCopy:false,
	ShowAwbCopyDetails:false,
	printcopy:'',
	awblrcopy:'',
	mpssticker:'',
	mpsstickerprint:'',
	bookingfield:'',
	awblrcopydata:{},
	mpsstickerdata:{},
	selectedAwbCopy:[null,null,null],
	selectedMpsCopy:[null,null],
	bookingfield1:'',
	bookingfield2:'',
	bookingfield3:'',
	bookinglabel1:'',
	bookinglabel2:'',
	bookinglabel3:'',
	bookingmpslabel1:'',
	bookingmpslabel2:'',
	bookingmpsfield1:'',
	bookingmpsfield2:'',
	bookingmpsfieldlist1:'',
	bookingmpsfieldlist2:'',
    ConsigneeCodeOnMps:"",
	clientdata:{},
	RelianceSecondaryClient:"",
	ProofOfPickup:"",
  ShowGlobalPickup:false,
  globalpickuppincodedataArray:[],
  globalpickup:'',
  pincode:[],
  ShowClientDetailsforglobalpickup:false,
  GlobalPickupClientPincodeData:{},
  disablesave:false,
  isDwsScanEnable:'',
	  dwshub:'',
    ShowGlobalDelivery:false,
    globaldeliverypincode:[],
    enableverification: "",
    prwtthreshold:500,
    blockclient: false,
    blockpickup : 0,
    blockdelivery : 0,
    blockclientreason:"",
    blockclientcode : {},
    globaldeliveryflag:'',
    MaxPhyWt : null,
    MaxPhyWtAWB : null
    }
  },
  computed: {
  },
  async mounted() {
    this.isLoading=true
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub = userdetail.hubID[0];
    await Promise.all([this.getStatelist(),this.loadAllHubAccessList(),this.getCompanyShortName(),this.getRoleList()]);
    await this.getAdminSettings();
    this.isLoading=false

  },
  methods: {
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async loadAllHubAccessList() {
      try {
        let InputPayload = {};
      //this.isLoading = true;
      let response = await MasterService.GetHublist(InputPayload);
      if(response.data.code===200){
        this.hubaccess = response.data.data.data;
        for (var i = 0; i < this.hubaccess.length; i++) {
          this.hubaccessObjArray.push({
            hubid: this.hubaccess[i].HubID,
            hubname: this.hubaccess[i].HubName
          })
        }
        let getcurrenthubobj = this.hubaccess.find(hubs => hubs.HubID == this.currentHub );
        this.hubid = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        this.hubid1 = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
		this.dwshub = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        let payload ={
          username: this.useremail,
          hubid:this.currentHub
        }
        let scandata = await AdminSettingsService.getAdminSettings(payload);
        if(scandata.data.data.hubdata){
          this.isPalletScan = scandata.data.data.hubdata.ispalletscan
          this.scanType = scandata.data.data.hubdata.scantype
		  this.isDwsScanEnable = scandata.data.data.hubdata.isdwsscanenable
        }
        }
        else {
          this.$alertify.error(response.data.message);
        }
        //this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getAdminSettings(){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail
        }
        let result = await AdminSettingsService.getAdminSettings(inputPayload);
        this.adminsettingdata = result.data.data.settings;
        let tempHSN = this.getValueByKeyName('EXEMHSN').HSN;
        this.HSNCode = tempHSN.join(",");

        let tempStates = this.getValueByKeyName('EBN1LAC').STATES;
        this.SelectedStates=[];
        this.StatesLimit.forEach(item=>{
          if(tempStates.includes(item.statename)){
            this.SelectedStates.push({
              'statename': item.statename.toUpperCase()
            })
          }
        })
        let temproles = this.getValueByKeyName('PRQCONFIG');
        this.roleId=[];
        this.RolesList.forEach(item=>{
          if(temproles.includes(item.rolename)){
            this.roleId.push({
              'rolename': item.rolename
            })
          }
        })
        let tempOriginHubids = this.getValueByKeyName('originhubids');
        let tempOriginArr = [];
        for(var i =0; i<tempOriginHubids.length; i++){
          let hubname = await this.getHubName(tempOriginHubids[i]);
          let hubdetails = {
            hubid: tempOriginHubids[i],
            hubname: hubname
          };
          tempOriginArr.push(hubdetails);
        }
        this.originhubids = tempOriginArr;

        let tempDestHubids = this.getValueByKeyName('destinationhubids');
        let tempDestArr = [];
        for(var i =0; i<tempDestHubids.length; i++){
          let hubname = await this.getHubName(tempDestHubids[i]);
          let hubdetails = {
            hubid: tempDestHubids[i],
            hubname: hubname
          };
          tempDestArr.push(hubdetails);
        }
        this.destinationhubids = tempDestArr;

        this.printstickeroptions = JSON.stringify(this.getValueByKeyName('PRINTTYPELIST'));
        this.MaxVolWt = this.getValueByKeyName('MAXVOLWT')[0];
        this.MaxVolWtAWB = this.getValueByKeyName('MAXVOLWT')[1];
        this.MaxPhyWt = this.getValueByKeyName('MAXPHYWT')[0];
        this.MaxPhyWtAWB = this.getValueByKeyName('MAXPHYWT')[1];
        this.globaldeliveryflag = this.getValueByKeyName('GLOBALDELIVERYFLAG')[0];
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    getHubName(hubid) {
      for (var i = 0; i < this.hubaccessObjArray.length; i++) {
        if (this.hubaccessObjArray[i].hubid == hubid) {
          return this.hubaccessObjArray[i].hubname;
        }
      }
    },
    getValueByKeyName(key) {
      for (var i = 0; i < this.adminsettingdata.length; i++) {
        if (this.adminsettingdata[i].key == key) {
          return this.adminsettingdata[i].value;
        }
      }
    },
	async getStatelist(){
      try {
        this.StatesLimit = [];
        let result = await MasterService.getStateList();
        result.data.data.forEach(item=>{
          this.StatesLimit.push({
            'statename': item.statename.toUpperCase()
          })
        })
      }  catch(err){
        console.log(err);
      }
    },
    async getCompanyShortName(){
      try {
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload)
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
            'clientId': CompanyShortList[i].clientid,
            'clientName': CompanyShortList[i].clientshortname,
          });

          this.ClientBusinessAccountlist.push({
            'clientId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          });
		  this.ClientOTPlist.push({
			'clientId':CompanyShortList[i].clientid,
            'clientBusinessAccountId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          });
        }
      } catch(err){
        console.log(err);
      }
    },
    async saveAdminSettings(module,field){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail,
        }
        if (module == "booking") {
          if(field=="hsncode"){
            let hsncode = this.HSNCode.split(",");
            inputPayload.exemptHSN = {"HSN": hsncode };
          }
          if(field=="limitstate"){
            let states = this.SelectedStates.map(el=>el.statename);
            inputPayload.states = {"STATES": states };
          }
          let tempOriginArr = [];
          let tempDestinationArr = [];
          if(field=="printsticker"){
            inputPayload.printstickeroptions = this.printstickeroptions;
          }
          if(field=="originhubids"){
            for(var i =0; i<this.originhubids.length; i++){
              tempOriginArr.push(this.originhubids[i].hubid);
            }
            inputPayload.originhubids = tempOriginArr;
          }
          if(field=="destinationhubids"){
            for(var i =0; i<this.destinationhubids.length; i++){
              tempDestinationArr.push(this.destinationhubids[i].hubid);
            }
            inputPayload.destinationhubids = tempDestinationArr;
          }
          
          let tempVolWt = []
          tempVolWt.push(parseInt(this.MaxVolWt))
          tempVolWt.push(parseInt(this.MaxVolWtAWB))
          if(field=='maxvolmpsawb'){
            inputPayload.MaxVolWt = tempVolWt;
          }
          let tempPhyWt = []
          tempPhyWt.push(parseInt(this.MaxPhyWt))
          tempPhyWt.push(parseInt(this.MaxPhyWtAWB))
          if(field=='maxphympsawb'){
            if (this.MaxPhyWt >= this.MaxPhyWtAWB) {
              this.$alert("Max physical wt per MPS should be less than Max physical wt per MPS",'Admin Setting', "error");
              this.isLoading = false;
              return false;
            }
            inputPayload.MaxPhyWt = tempPhyWt;
          }
        }
        let result = await AdminSettingsService.saveAdminSettings(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
		  await this.getAdminSettings();
          this.$alert(result.data.message, "", "success");
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getRoleList(){
      try {
        //this.isLoading = true;
        this.RolesList = [];
        let result = await MasterService.getRolesList();
        //this.isLoading = false;
        if (result.data.code == 200) {
          result.data.data.rows.forEach(item=>{
              this.RolesList.push({
                'rolename':item.rolename
              });
          })
        }else {
          this.rolesList = [];
          this.$alert("Internal Server Error",'Admin Setting', "error");
        }
      }  catch(err){
        console.log(err);
      }
    },
  }
}
Validator.extend('verify_hsncode', {
  getMessage: field => "Invalid HSN Code entered.",
  validate: value => {
    var HSNCode = $("#HsnCode").val();
    let HCode=HSNCode.split(/[,]+/);
    let flag=0;
    for (let i = 0; i < HCode.length; i++) {
      if(isNaN(HCode[i]) ){
        flag=1;
      }
    }
    if(flag==1){
      return false;
    }else{
      return true;
    }
  }
});
Validator.extend('verify_states', {
  getMessage: field => "Invalid name(s) of state(s) entered.",
  validate: value => {
    var stateslist = $("#StatesLimit").val();
    let statenames=stateslist.split(/[,]+/);
    let flag=0;
    if(flag==1){
      return false;
    }else{
      return true;
    }
  }
});
Validator.extend('verify_prcutoff', {
  getMessage: field => "Invalid PR Cut-Off time entered.",
  validate: value => {
    var PRCutofftime = $("#prcutofftime").val();
    if (PRCutofftime.length!=5) {
      return false
    }
    let PRCutoff=PRCutofftime.split(":");
    if (PRCutoff[0].length== 2 && PRCutoff[1].length== 2) {
      return true;
    } else{
      return false;
    }
  }
});
Validator.extend('verify_pincode', {
  getMessage: field => "The Pincode field format is invalid",
  validate: value => {
  if ( value.match(/^\d{6}(,\d{6})*$/)) {
    this.disablesave=false
  return true
  }else{
    this.disablesave=true
  return false;
  }
  }
  });
Validator.extend('verify_deliverypincode', {
  getMessage: field => "The Pincode field format is invalid",
  validate: value => {
    if (value.match(/^\d{6}(,\d{6})*$/)) {
      this.disablesave = false
      return true
    } else {
      this.disablesave = true
      return false;
    }
  }
  });
  



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/configuration/cargobooking/cargobookingconfiguration.component.js